import src from "IMAGE";
export default { src, width: 2328, height: 662, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAIAAADq9gq6AAAAPUlEQVR42gEyAM3/AOq8cuhhSdtdS52+lMjRgNjci9Lu1+fy7QDkp0DmVDnMVUGsr5LZ27uI0ZRe2ZaX5b0Y3B/BGoe6AgAAAABJRU5ErkJggg=="};
